export default "__VITE_ASSET__hPQGWYs0__"